import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["question", "onChangeAnswer", "answers", "disabled", "matchingQuestionLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from 'styled-components';
import { SingleSelectInput } from '@lib/common';
import { Row, Col } from 'antd';
import { SubmissionBaseQuestion } from './base-question.component';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledMatchingAnswerWrapper = styled(Row).withConfig({
  displayName: "matchingcomponent__StyledMatchingAnswerWrapper",
  componentId: "sc-1387dhm-0"
})([".ant-input-affix-wrapper{height:100%;}margin-bottom:8px;"]);
var StyledTextDescription = styled.div.withConfig({
  displayName: "matchingcomponent__StyledTextDescription",
  componentId: "sc-1387dhm-1"
})(["padding:6.5px 11px 6.5px 4px;font-size:16px;margin-left:4px;"]);
var StyledQuestionDescriptionWrapper = styled(Col).withConfig({
  displayName: "matchingcomponent__StyledQuestionDescriptionWrapper",
  componentId: "sc-1387dhm-2"
})(["display:flex;align-items:center;"]);
var StyledQuestionIndex = styled.div.withConfig({
  displayName: "matchingcomponent__StyledQuestionIndex",
  componentId: "sc-1387dhm-3"
})(["min-width:32px;text-align:center;"]);
export var SubmissionMatchingQuestion = function SubmissionMatchingQuestion(_ref) {
  var _question$subQuestion;

  var question = _ref.question,
      onChangeAnswer = _ref.onChangeAnswer,
      answers = _ref.answers,
      disabled = _ref.disabled,
      matchingQuestionLabel = _ref.matchingQuestionLabel,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleChangeAnswer = function handleChangeAnswer(subQuestionId, answerId) {
    onChangeAnswer(subQuestionId, answerId);
  };

  return /*#__PURE__*/_jsx(SubmissionBaseQuestion, _objectSpread(_objectSpread({
    question: question
  }, props), {}, {
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: (_question$subQuestion = question.subQuestions) === null || _question$subQuestion === void 0 ? void 0 : _question$subQuestion.map(function (subQ, index) {
        var _answers$find, _answers$find$value, _question$answers;

        return /*#__PURE__*/_jsxs(StyledMatchingAnswerWrapper, {
          align: "middle",
          gutter: [8, 16],
          children: [/*#__PURE__*/_jsxs(StyledQuestionDescriptionWrapper, {
            span: 18,
            children: [/*#__PURE__*/_jsxs(StyledQuestionIndex, {
              children: ["(", index + question.index, ")"]
            }), /*#__PURE__*/_jsx(StyledTextDescription, {
              children: subQ.description
            })]
          }), /*#__PURE__*/_jsx(Col, {
            span: 6,
            children: /*#__PURE__*/_jsx(SingleSelectInput, {
              disabled: disabled,
              placeholder: matchingQuestionLabel.selectAnswer,
              value: answers === null || answers === void 0 ? void 0 : (_answers$find = answers.find(function (a) {
                return a.subQuestionId === subQ.id.toString();
              })) === null || _answers$find === void 0 ? void 0 : (_answers$find$value = _answers$find.value) === null || _answers$find$value === void 0 ? void 0 : _answers$find$value.answerId.toString(),
              options: ((_question$answers = question.answers) === null || _question$answers === void 0 ? void 0 : _question$answers.length) > 0 && question.answers.map(function (a) {
                return {
                  value: a.id.toString(),
                  label: a.description
                };
              }),
              onChange: function onChange(value) {
                return handleChangeAnswer(subQ.id.toString(), value);
              }
            })
          })]
        }, subQ.id.toString());
      })
    })
  }));
};